import React, { FC } from 'react';
import { TinyEditor } from '@/editor/PageEditor/EditorBlock/TextBlock/TinyEditor';

export interface WysiwygEditorProps {
  value: string;
  onChange: (value: string) => void;
  blockPath?: string;
  toolbar?: string;
  /** Adds a "split here" button: the text after the cursor is handed over, and only the text before stays */
  onSplit?: (before: string, after: string) => void;
}

export const WysiwygEditor: FC<
  WysiwygEditorProps & {
    type: 'tinymce';
  }
> = ({ type, ...rest }) => {
  if (type === 'tinymce') {
    return <TinyEditor {...rest} />;
  }

  // console.warn('Unknown WysiwygEditor type', type);
  return null;
};
